import React, { useState, lazy } from 'react';
import { Menu, X, Facebook, Instagram } from 'lucide-react';
import { Button } from './ui/Button';
interface HeaderProps {
  onJoinClick?: () => void;
}
export function Header({
  onJoinClick
}: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navItems = [{
    label: 'HOME',
    href: '/'
  }, {
    label: 'STORAGE FACILITY',
    href: '/#features'
  }, {
    label: 'SECURITY & TERMS',
    href: '/#security'
  }, {
    label: 'REGISTER INTEREST',
    href: '/#pricing'
  }, {
    label: 'CONTACT US',
    href: '/#contact'
  }];
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-330">
      {/* Social Bar */}
      <div className="absolute top-0 left-0 p-2 hidden lg:flex gap-2" data-id="element-331">
        <a href="#" className="text-gray-400 hover:text-[#1A7B7E] transition-colors" data-id="element-332">
          <Facebook className="h-4 w-4" data-id="element-333" />
        </a>
        <a href="#" className="text-gray-400 hover:text-[#1A7B7E] transition-colors" data-id="element-334">
          <Instagram className="h-4 w-4" data-id="element-335" />
        </a>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <div className="flex justify-between items-center h-24" data-id="element-337">
          {/* Logo - optimized for above-fold loading */}
          <a href="/" className="flex-shrink-0 cursor-pointer group" data-id="element-338">
            <img src="https://cdn.magicpatterns.com/uploads/sPuCkrU9wFqa1ZM4R9vTuA/231537469_2.png" alt="HOLDMYVAN" className="h-16 w-auto group-hover:opacity-80 transition-opacity" loading="eager" fetchPriority="high" width="200" height="64" data-id="element-339" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6" data-id="element-340">
            {navItems.map(item => <a key={item.label} href={item.href} className="text-base font-bold text-gray-700 hover:text-[#1A7B7E] transition-colors uppercase tracking-wide" data-id="element-341">
                {item.label}
              </a>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-342">
            <Button variant="secondary" size="sm" onClick={onJoinClick} data-id="element-343">
              Join the priority list
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden" data-id="element-344">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-[#1A7B7E] p-2" data-id="element-345">
              {isMenuOpen ? <X className="h-8 w-8" data-id="element-346" /> : <Menu className="h-8 w-8" data-id="element-347" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-348">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-349">
            {navItems.map(item => <a key={item.label} href={item.href} className="block px-3 py-2 text-lg font-bold text-gray-700 hover:text-[#1A7B7E] hover:bg-gray-50 uppercase" onClick={() => setIsMenuOpen(false)} data-id="element-350">
                {item.label}
              </a>)}
            <div className="mt-4 px-3" data-id="element-351">
              <Button variant="secondary" className="w-full" onClick={onJoinClick} data-id="element-352">
                Join the priority list
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}